import { COLORS } from '@/styles/colors';
import { flexCenter } from '@/styles/layout';
import styled, { css } from 'styled-components';
import { BoxWrapper } from '../Box/styles';

export const IconButtonContainer = styled(BoxWrapper)<{ svgPath?: 'fill' | 'stroke' }>`
  ${flexCenter};
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${COLORS.grey[400]};
  background-color: ${COLORS.white};
  cursor: pointer;

  ${({ width }) => css`
    width: ${width};
  `}

  ${({ height }) => css`
    height: ${height};
  `}

  &:disabled {
    pointer-events: none;

    path {
      ${({ svgPath }) =>
        svgPath &&
        `
        ${[svgPath]}: ${COLORS.grey[300]};
      `}
    }
  }

  &:hover {
    border: 1px solid ${COLORS.grey[600]};

    path {
      transition:
        fill 0.1s ease,
        stroke 0.1s ease;
      ${({ svgPath }) =>
        svgPath &&
        `
        ${[svgPath]}: ${COLORS.green[600]};
      `}
    }
  }
`;
